import { useEffect, useState } from "react";
import { Users } from "lucide-react";
import { endpoints } from "@/lib/api";

// Shows the LIVE total registered-member count (count only, no personal data) + the family message.
export const MembersBadge = ({ className = "" }) => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () => endpoints.memberCount().then((r) => { if (alive) setCount(r.data?.count ?? null); }).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  return (
    <div data-testid="members-badge"
      className={`flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 rounded-2xl border border-[#273042] bg-gradient-to-r from-[#1a0c0e] to-[#121620] px-4 py-3 ${className}`}>
      <div className="flex items-center gap-2.5">
        <span className="w-10 h-10 rounded-xl bg-[#E11D2A]/15 flex items-center justify-center shrink-0">
          <Users className="w-5 h-5 text-[#E11D2A]" />
        </span>
        <div>
          <p className="text-2xl font-extrabold text-white leading-none tabular-nums" data-testid="members-count">
            {count === null ? "—" : count.toLocaleString()}
          </p>
          <p className="text-[11px] uppercase tracking-wider text-slate-400 mt-0.5">Registered members</p>
        </div>
      </div>
      <div className="sm:ml-auto sm:text-right">
        <p className="text-sm font-bold text-white">YOUR MEMBERSHIP MAKES ONE FAMILY</p>
        <p className="text-xs font-semibold text-[#E11D2A]">— B&amp;B KIGALI</p>
      </div>
    </div>
  );
};
